// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Halo Universe - Warp Gates Configuration
 * 
 * Slipspace portals connecting to other universes
 */

export const warpGates = [
  {
    id: 'gate-halo-masseffect',
    name: 'Slipspace Anomaly Alpha',
    type: 'warpgate',
    distance: 15,
    fromUniverse: 'halo',
    destinationUniverse: 'masseffect',
    fromSystem: 1800,
    toSystem: 900,
    destinationGate: 'gate-masseffect-halo',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'SLIPSPACE PORTAL',
    services: [],
    primaryColor: '#00ff00',
    secondaryColor: '#0088ff',
    hasRings: true,
    discovered: true,
    description: 'Slipspace rupture to Citadel space. Forerunner technology detected.'
  },
  {
    id: 'gate-halo-warhammer40k',
    name: 'Slipspace Anomaly Beta',
    type: 'warpgate',
    distance: 20,
    fromUniverse: 'halo',
    destinationUniverse: 'warhammer40k',
    fromSystem: 1800,
    toSystem: 1100,
    destinationGate: 'gate-warhammer40k-halo',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'HIGH',
    resources: 'SLIPSPACE PORTAL',
    services: [],
    primaryColor: '#00ff00',
    secondaryColor: '#ff0000',
    hasRings: true,
    discovered: false,
    description: 'Slipspace rupture to Imperium space. Warp and slipspace collide.'
  }
];

export const warpGatePositions = {
  'gate-halo-masseffect': { x: 62, y: 48, z: 5 },
  'gate-halo-warhammer40k': { x: 38, y: 52, z: -4 }
};
